/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientOrganismAntibioticSusceptibility } from 'app/shared/model/patient-organism-antibiotic-susceptibility.model';
import { IOrganism } from 'app/shared/model/organism.model';
import { IAntibiotic } from 'app/shared/model/antibiotic.model';

export interface IResistanceTrend {
  id?: string;
  resistanceRate?: number;
  trendPeriod?: string | null;
  notes?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  testReference?: IPatientOrganismAntibioticSusceptibility | null;
  organism?: IOrganism | null;
  antibiotic?: IAntibiotic | null;
}

export const defaultValue: Readonly<IResistanceTrend> = {
  active: false,
};
